import { removeElement } from "../../utils/array";
export class RenderingManager {
    get shadowGenerators() {
        return (this.mShadowGenerators);
    }
    constructor(pApp) {
        this.mApp = pApp;
        this.mShadowGenerators = new Array();
    }
    addShadowGenerator(pGenerator) {
        if (pGenerator != null)
            this.mShadowGenerators.push(pGenerator);
    }
    removeShadowGenerator(pGenerator) {
        if (pGenerator != null)
            removeElement(this.mShadowGenerators, pGenerator);
    }
    notifyModelInteraction() {
        for (const tShadowGenerator of this.mApp.rendering.shadowGenerators)
            tShadowGenerator.notifyModelInteraction();
    }
}
